import React, { useEffect, useState } from "react";
import Error from "../error/404";
import { useParams } from "react-router-dom";
import { appConstants } from "../../utils/constants";
import { conceptMap } from "../../utils/concept-enum";
import "../../assets/css/dashboard.css";

export const DynamicRouteManager = ({ children, surveyType }) => {
  let { qrValue } = useParams();
  qrValue = decodeURI(qrValue).trim();
  const [isError, setIsError] = useState(true);
  const isdigit = (value) => {
    const val = Number(value) ? true : false;
    return val;
  };

  useEffect(() => {
    if (
      ((surveyType === appConstants.store &&
        qrValue.length === appConstants.storeLength) ||
        (surveyType === appConstants.invoice &&
          qrValue.length === appConstants.invoiceLength)) &&
      isdigit(qrValue)
    ) {
      let concept = parseInt(qrValue.slice(0, 2), 10);
      let isValidConcept = conceptMap.get(concept);
      if (isValidConcept !== undefined) {
        localStorage.setItem(appConstants.conceptCode, concept);
        localStorage.setItem(appConstants.qrValue, qrValue);
        localStorage.setItem(appConstants.surveyType, surveyType);
        localStorage.setItem(appConstants.language, appConstants.en);
        // Store-specific: persist first 5 characters as store code
        if (
          surveyType === appConstants.store ||
          surveyType === appConstants.invoice
        ) {
          if (qrValue.length >= 5) {
            localStorage.setItem(appConstants.storeCode, qrValue.slice(0, 5));
          } else {
            setIsError(true);
            return;
          }
        }
        setIsError(false);
      }
    }
  }, [qrValue, surveyType]);

  if (isError) {
    return (
      <div className="content-error-background">
        <Error />
      </div>
    );
  }

  return children;
};
